var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.565,
    height: 33.707,
    viewBox: "0 0 28.565 33.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge-reward-medal-svgrepo-com",
    transform: "translate(-2.7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7079",
    "data-name": "Ellipse 7079",
    cx: 11.783,
    cy: 11.783,
    r: 11.783,
    transform: "translate(5.093 1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7080",
    "data-name": "Ellipse 7080",
    cx: 6.585,
    cy: 6.585,
    r: 6.585,
    transform: "translate(10.291 6.198)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16696",
    "data-name": "Path 16696",
    d: "M16.2,23.306l3.856,8.141,3.749-4.07,5.57-.321L25.3,18.7",
    transform: "translate(0.89 1.26)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16697",
    "data-name": "Path 16697",
    d: "M7.556,18.8,3.7,27.048l5.463.321,3.749,4.07L16.768,23.3",
    transform: "translate(0 1.267)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.2b88d56e1f8177f220f2a868dabf2fed.svg";
export { ForwardRef as ReactComponent };